import _objectWithoutProperties from "/codebuild/output/src3605572746/src/personal-website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/codebuild/output/src3605572746/src/personal-website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/codebuild/output/src3605572746/src/personal-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/codebuild/output/src3605572746/src/personal-website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["theme", "css", "__css", "sx"],
    _excluded2 = ["baseStyle"],
    _excluded3 = ["styleConfig"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// ../../react-shim.js
import React from "react"; // src/index.ts

export * from "@chakra-ui/color-mode";
export * from "@chakra-ui/styled-system";
import { keyframes } from "@emotion/react"; // src/hooks.ts

import { useColorMode } from "@chakra-ui/color-mode"; // src/use-theme.ts

import { ThemeContext } from "@emotion/react";
import { useContext } from "react";

function useTheme() {
  var theme = useContext(ThemeContext);

  if (!theme) {
    throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
  }

  return theme;
} // src/hooks.ts


function useChakra() {
  var colorModeResult = useColorMode();
  var theme = useTheme();
  return _objectSpread(_objectSpread({}, colorModeResult), {}, {
    theme: theme
  });
}

function getBreakpointValue(theme, value, fallback) {
  var _ref, _getValue;

  if (value == null) return value;

  var getValue = function getValue(val) {
    var _a, _b;

    return (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.asArray) == null ? void 0 : _b[val];
  };

  return (_ref = (_getValue = getValue(value)) !== null && _getValue !== void 0 ? _getValue : getValue(fallback)) !== null && _ref !== void 0 ? _ref : fallback;
}

function getTokenValue(theme, value, fallback) {
  var _ref2, _getValue2;

  if (value == null) return value;

  var getValue = function getValue(val) {
    var _a, _b;

    return (_b = (_a = theme.__cssMap) == null ? void 0 : _a[val]) == null ? void 0 : _b.value;
  };

  return (_ref2 = (_getValue2 = getValue(value)) !== null && _getValue2 !== void 0 ? _getValue2 : getValue(fallback)) !== null && _ref2 !== void 0 ? _ref2 : fallback;
}

function useToken(scale, token, fallback) {
  var theme = useTheme();
  return getToken(scale, token, fallback)(theme);
}

function getToken(scale, token, fallback) {
  var _token = Array.isArray(token) ? token : [token];

  var _fallback = Array.isArray(fallback) ? fallback : [fallback];

  return function (theme) {
    var fallbackArr = _fallback.filter(Boolean);

    var result = _token.map(function (token2, index) {
      var _fallbackArr$index2;

      if (scale === "breakpoints") {
        var _fallbackArr$index;

        return getBreakpointValue(theme, token2, (_fallbackArr$index = fallbackArr[index]) !== null && _fallbackArr$index !== void 0 ? _fallbackArr$index : token2);
      }

      var path = "".concat(scale, ".").concat(token2);
      return getTokenValue(theme, path, (_fallbackArr$index2 = fallbackArr[index]) !== null && _fallbackArr$index2 !== void 0 ? _fallbackArr$index2 : token2);
    });

    return Array.isArray(token) ? result : result[0];
  };
} // src/providers.tsx


import { useColorMode as useColorMode2 } from "@chakra-ui/color-mode";
import { createContext } from "@chakra-ui/react-utils";
import { css, toCSSVar } from "@chakra-ui/styled-system";
import { memoizedGet as get, runIfFn } from "@chakra-ui/utils";
import { Global, ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { useMemo } from "react";

function ThemeProvider(props) {
  var cssVarsRoot = props.cssVarsRoot,
      theme = props.theme,
      children = props.children;
  var computedTheme = useMemo(function () {
    return toCSSVar(theme);
  }, [theme]);
  return /* @__PURE__ */React.createElement(EmotionThemeProvider, {
    theme: computedTheme
  }, /* @__PURE__ */React.createElement(CSSVars, {
    root: cssVarsRoot
  }), children);
}

function CSSVars(_ref3) {
  var _ref3$root = _ref3.root,
      root = _ref3$root === void 0 ? ":host, :root" : _ref3$root;
  var selector = [root, "[data-theme]"].join(",");
  return /* @__PURE__ */React.createElement(Global, {
    styles: function styles(theme) {
      return _defineProperty({}, selector, theme.__cssVars);
    }
  });
}

var _createContext = createContext({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    StylesProvider = _createContext2[0],
    useStyles = _createContext2[1];

function createStylesContext(componentName) {
  return createContext({
    name: "".concat(componentName, "StylesContext"),
    errorMessage: "useStyles: \"styles\" is undefined. Seems you forgot to wrap the components in \"<".concat(componentName, " />\" ")
  });
}

function GlobalStyle() {
  var _useColorMode = useColorMode2(),
      colorMode = _useColorMode.colorMode;

  return /* @__PURE__ */React.createElement(Global, {
    styles: function styles(theme) {
      var styleObjectOrFn = get(theme, "styles.global");
      var globalStyles = runIfFn(styleObjectOrFn, {
        theme: theme,
        colorMode: colorMode
      });
      if (!globalStyles) return void 0;
      var styles = css(globalStyles)(theme);
      return styles;
    }
  });
} // src/system.ts


import { css as css2, isStyleProp } from "@chakra-ui/styled-system";
import { filterUndefined, objectFilter, runIfFn as runIfFn2 } from "@chakra-ui/utils";
import emotionStyled from "@emotion/styled"; // src/should-forward-prop.ts

import { propNames } from "@chakra-ui/styled-system";
var allPropNames = /* @__PURE__ */new Set([].concat(_toConsumableArray(propNames), ["textStyle", "layerStyle", "apply", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"]));
var validHTMLProps = /* @__PURE__ */new Set(["htmlWidth", "htmlHeight", "htmlSize"]);

function shouldForwardProp(prop) {
  return validHTMLProps.has(prop) || !allPropNames.has(prop);
} // src/system.ts


var toCSSObject = function toCSSObject(_ref4) {
  var baseStyle = _ref4.baseStyle;
  return function (props) {
    var theme = props.theme,
        cssProp = props.css,
        __css = props.__css,
        sx = props.sx,
        rest = _objectWithoutProperties(props, _excluded);

    var styleProps = objectFilter(rest, function (_, prop) {
      return isStyleProp(prop);
    });
    var finalBaseStyle = runIfFn2(baseStyle, props);
    var finalStyles = Object.assign({}, __css, finalBaseStyle, filterUndefined(styleProps), sx);
    var computedCSS = css2(finalStyles)(props.theme);
    return cssProp ? [computedCSS, cssProp] : computedCSS;
  };
};

function styled(component, options) {
  var _ref5 = options !== null && options !== void 0 ? options : {},
      baseStyle = _ref5.baseStyle,
      styledOptions = _objectWithoutProperties(_ref5, _excluded2);

  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }

  var styleObject = toCSSObject({
    baseStyle: baseStyle
  });
  return emotionStyled(component, styledOptions)(styleObject);
} // src/forward-ref.tsx


import { forwardRef as forwardReactRef } from "react";

function forwardRef(component) {
  return forwardReactRef(component);
} // src/use-style-config.ts


import { resolveStyleConfig } from "@chakra-ui/styled-system";
import { filterUndefined as filterUndefined2, memoizedGet as get2, mergeWith, omit } from "@chakra-ui/utils";
import { useRef } from "react";
import isEqual from "react-fast-compare";

function useStyleConfigImpl(themeKey) {
  var _ref6;

  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var styleConfigProp = props.styleConfig,
      rest = _objectWithoutProperties(props, _excluded3);

  var _useChakra = useChakra(),
      theme = _useChakra.theme,
      colorMode = _useChakra.colorMode;

  var themeStyleConfig = get2(theme, "components.".concat(themeKey));
  var styleConfig = styleConfigProp || themeStyleConfig;
  var mergedProps = mergeWith({
    theme: theme,
    colorMode: colorMode
  }, (_ref6 = styleConfig == null ? void 0 : styleConfig.defaultProps) !== null && _ref6 !== void 0 ? _ref6 : {}, filterUndefined2(omit(rest, ["children"])));
  var stylesRef = useRef({});

  if (styleConfig) {
    var getStyles = resolveStyleConfig(styleConfig);
    var styles = getStyles(mergedProps);
    var isStyleEqual = isEqual(stylesRef.current, styles);

    if (!isStyleEqual) {
      stylesRef.current = styles;
    }
  }

  return stylesRef.current;
}

function useStyleConfig(themeKey) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return useStyleConfigImpl(themeKey, props);
}

function useMultiStyleConfig(themeKey) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return useStyleConfigImpl(themeKey, props);
} // src/factory.ts


function factory() {
  var cache = /* @__PURE__ */new Map();
  return new Proxy(styled, {
    apply: function apply(target, thisArg, argArray) {
      return styled.apply(void 0, _toConsumableArray(argArray));
    },
    get: function get(_, element) {
      if (!cache.has(element)) {
        cache.set(element, styled(element));
      }

      return cache.get(element);
    }
  });
}

var chakra = factory();
export { CSSVars, GlobalStyle, StylesProvider, ThemeProvider, chakra, createStylesContext, forwardRef, getToken, keyframes, shouldForwardProp, styled, toCSSObject, useChakra, useMultiStyleConfig, useStyleConfig, useStyles, useTheme, useToken };